import Chip from "@mui/material/Chip";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import AutorenewRoundedIcon from "@mui/icons-material/AutorenewRounded";
import { PumpEntryStatus } from "../../../interfaces/interfaces";

const statusConfig = {
  "in-stock": {
    label: "In stock",
    color: "#237A57",
    bg: "#E7F5EE",
    icon: <Inventory2RoundedIcon />,
  },
  reused: {
    label: "Reused",
    color: "#2A6FB0",
    bg: "#E8F1FB",
    icon: <AutorenewRoundedIcon />,
  },
};

export const PumpStatusBadge = ({ status }: { status: PumpEntryStatus }) => {
  const config = statusConfig[status];
  return (
    <Chip
      size="small"
      icon={config.icon}
      label={config.label}
      sx={{
        height: 27,
        bgcolor: config.bg,
        color: config.color,
        border: `1px solid ${config.color}22`,
        fontWeight: 700,
        fontSize: 11,
        "& .MuiChip-icon": { color: config.color, fontSize: 16 },
      }}
    />
  );
};
